import React, { useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { UiLeftSidebarLayout } from "./LeftSidebarLayout.style";
/**
 * 左側欄layout
 */

const LeftSidebarLayout = ({
  header,
  sidebar,
  children,
  version = "localhost"
}) => {
  const [isShow, setState] = useState(false);

  const toggleSidebar = () => {
    setState(!isShow);
  };

  return /*#__PURE__*/React.createElement(UiLeftSidebarLayout, null, /*#__PURE__*/React.createElement("div", {
    className: "header"
  }, isShow && /*#__PURE__*/React.createElement("i", {
    className: "material-icons",
    onClick: () => toggleSidebar()
  }, "menu"), header), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames("sidebar", {
      noActive: isShow
    })
  }, sidebar, /*#__PURE__*/React.createElement("div", {
    className: "version"
  }, version), /*#__PURE__*/React.createElement("div", {
    className: "action"
  }, /*#__PURE__*/React.createElement("i", {
    className: "material-icons",
    onClick: () => toggleSidebar()
  }, "navigate_before"))), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "scroll"
  }, children))));
};

export default LeftSidebarLayout;
LeftSidebarLayout.propTypes = {
  header: PropTypes.element,
  sidebar: PropTypes.element,
  children: PropTypes.node,
  version: PropTypes.string
};